import { Store } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { createWhitelistFilter } from "redux-persist-transform-filter";
import localForage from "localforage";

import { IApplicationState } from "./application-state";

export const createPersistReducer = (rootReducer: any) => {
    const persistConfig = {
        key: "a5abe301-fc4c-4094-aa2c-8dfbb528cc11",
        timeout: 0,
        storage: localForage,
        whitelist: [
            "dsDashboard"
        ],
        transforms: [
            createWhitelistFilter("dsDashboard", [
                "activeDashboardViews",
                "codeViewData",
                "jsonViewData",
                "erdViewData",
                "erdViewMetaData",
                "protobufViewData",
                "generatedProtobufData",
                "sqlViewData"
                // "check"
            ])
        ]
    };

    return persistReducer(persistConfig, rootReducer);
};

export const createPersistStore = (store: Store<IApplicationState>) => persistStore(store);
